import api from '../../services/api'
import { formatarDocumentoParcial } from './cadastroFinanceiroDocumentoOrigem'

export const TIPO_ORIGEM_FINANCEIRO = {
  CLIENTE: 'CLIENTE',
  OUTRO: 'OUTRO',
}

export const TIPO_ORIGEM_OPCOES = [
  { value: TIPO_ORIGEM_FINANCEIRO.CLIENTE, label: 'Cliente cadastrado' },
  { value: TIPO_ORIGEM_FINANCEIRO.OUTRO, label: 'Outra origem (texto)' },
]

export const CLIENTE_TEXTO_PREFIX = '__txt__'

export function formatarCnpjExibicao(cnpj) {
  if (!cnpj) return ''
  const d = String(cnpj).replace(/\D/g, '')
  if (d.length !== 14) return d.length > 0 ? d : ''
  return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
}

export function formatarCpfExibicao(cpf) {
  if (!cpf) return ''
  const d = String(cpf).replace(/\D/g, '')
  if (d.length !== 11) return d.length > 0 ? d : ''
  return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4')
}

/** Formata CPF ou CNPJ para exibição no campo de origem. */
export function formatarDocumentoOrigemExibicao(doc) {
  const d = String(doc ?? '').replace(/\D/g, '')
  if (!d) return ''
  return formatarDocumentoParcial(d)
}

export function somenteDigitosCnpj(valor) {
  const d = String(valor ?? '').replace(/\D/g, '')
  return d.length > 0 ? d : null
}

export function formatarDocumentoClienteExibicao(cnpj, cpf) {
  const cnpjFmt = formatarCnpjExibicao(cnpj)
  if (cnpjFmt) return cnpjFmt
  return formatarCpfExibicao(cpf)
}

export function formatarLabelCliente(nome, cnpj, cpf) {
  const n = String(nome ?? '').trim()
  const doc = formatarDocumentoClienteExibicao(cnpj, cpf)
  if (n && doc) return `${n} — ${doc}`
  return n || doc || ''
}

export function parceiroApiParaSelect(item) {
  const nome = item?.nome ?? item?.pessoa?.pes_nome ?? ''
  const cnpj = item?.cnpj ?? item?.pessoa?.juridica?.jur_cnpj ?? null
  const cpf = item?.cpf ?? item?.pessoa?.fisica?.fis_cpf ?? null
  const parId = item?.par_id ?? item?.value
  return {
    value: parId != null && parId !== '' ? Number(parId) || parId : parId,
    label: formatarLabelCliente(nome, cnpj, cpf),
    nome,
    cnpj,
    cpf,
  }
}

export function textoLivreParaSelect(texto) {
  const t = String(texto ?? '').trim()
  return {
    value: `${CLIENTE_TEXTO_PREFIX}${t}`,
    label: t,
    __isNew__: true,
  }
}

export function isClienteTextoLivre(opt) {
  if (!opt) return false
  if (opt.__isNew__) return true
  return String(opt.value ?? '').startsWith(CLIENTE_TEXTO_PREFIX)
}

const CAMPOS_ORIGEM_OUTRO_VAZIOS = {
  origemRazaoSocial: '',
  origemNomeFantasia: '',
  origemEndereco: '',
  origemTexto: '',
  origemCnpj: '',
  clienteTexto: null,
}

/** Estado inicial / edição dos campos de origem no formulário. */
export function origemEdicaoFromApi(payload) {
  const parceiroId =
    payload?.cliente?.par_id ??
    payload?.parceiro_id ??
    null

  if (parceiroId != null && Number(parceiroId) > 0) {
    return {
      tipoOrigem: TIPO_ORIGEM_FINANCEIRO.CLIENTE,
      cliente: clienteEdicaoParaSelect(payload),
      ...CAMPOS_ORIGEM_OUTRO_VAZIOS,
    }
  }

  const razao = String(
    payload?.origem_razao_social ?? payload?.cliente_texto ?? ''
  ).trim()
  const fantasia = String(payload?.origem_nome_fantasia ?? '').trim()
  const endereco = String(payload?.origem_endereco ?? '').trim()
  const cnpj = formatarDocumentoOrigemExibicao(payload?.origem_cnpj)

  if (razao !== '' || fantasia !== '' || endereco !== '' || cnpj !== '') {
    return {
      tipoOrigem: TIPO_ORIGEM_FINANCEIRO.OUTRO,
      cliente: null,
      origemRazaoSocial: razao,
      origemNomeFantasia: fantasia,
      origemEndereco: endereco,
      origemTexto: razao,
      origemCnpj: cnpj,
      clienteTexto: razao || fantasia || null,
    }
  }

  return {
    tipoOrigem: TIPO_ORIGEM_FINANCEIRO.CLIENTE,
    cliente: null,
    ...CAMPOS_ORIGEM_OUTRO_VAZIOS,
  }
}

export function clienteEdicaoParaSelect(payload) {
  if (payload?.cliente?.par_id) {
    return parceiroApiParaSelect({
      par_id: payload.cliente.par_id,
      nome: payload.cliente.pessoa?.pes_nome,
      cnpj: payload.cliente.cnpj,
      cpf: payload.cliente.cpf,
    })
  }
  if (payload?.parceiro_id) {
    return parceiroApiParaSelect({
      par_id: payload.parceiro_id,
      nome: payload?.parceiro?.pessoa?.pes_nome,
      cnpj: payload?.parceiro?.cnpj,
      cpf: payload?.parceiro?.cpf,
    })
  }
  return null
}

/** Payload API a partir do estado do formulário. */
export function origemParaPayload(cadastro) {
  const tipo = cadastro?.tipoOrigem ?? TIPO_ORIGEM_FINANCEIRO.CLIENTE

  if (tipo === TIPO_ORIGEM_FINANCEIRO.CLIENTE) {
    const cliente = cadastro?.cliente
    if (
      cliente &&
      !isClienteTextoLivre(cliente) &&
      cliente.value != null &&
      cliente.value !== ''
    ) {
      return {
        tipo_origem: TIPO_ORIGEM_FINANCEIRO.CLIENTE,
        parceiro_id: Number(cliente.value),
        cliente_id: Number(cliente.value),
        cliente_texto: null,
        origem_cnpj: null,
        origem_razao_social: null,
        origem_nome_fantasia: null,
        origem_endereco: null,
      }
    }

    return {
      tipo_origem: TIPO_ORIGEM_FINANCEIRO.CLIENTE,
      parceiro_id: null,
      cliente_id: null,
      cliente_texto: null,
      origem_cnpj: null,
      origem_razao_social: null,
      origem_nome_fantasia: null,
      origem_endereco: null,
    }
  }

  const razao = String(cadastro?.origemRazaoSocial ?? cadastro?.origemTexto ?? '').trim()
  const fantasia = String(cadastro?.origemNomeFantasia ?? '').trim()
  const endereco = String(cadastro?.origemEndereco ?? '').trim()
  const cnpj = somenteDigitosCnpj(cadastro?.origemCnpj)
  const clienteTexto = razao || fantasia || null

  return {
    tipo_origem: TIPO_ORIGEM_FINANCEIRO.OUTRO,
    parceiro_id: null,
    cliente_id: null,
    cliente_texto: clienteTexto,
    origem_cnpj: cnpj,
    origem_razao_social: razao !== '' ? razao : null,
    origem_nome_fantasia: fantasia !== '' ? fantasia : null,
    origem_endereco: endereco !== '' ? endereco : null,
    origemTexto: razao,
    origemRazaoSocial: razao,
    origemNomeFantasia: fantasia,
    origemEndereco: endereco,
  }
}

/** @deprecated Use origemParaPayload */
export function clienteSelectParaPayload(cliente, clienteTexto) {
  return origemParaPayload({
    tipoOrigem: TIPO_ORIGEM_FINANCEIRO.OUTRO,
    cliente,
    origemTexto: clienteTexto,
    origemRazaoSocial: clienteTexto,
    clienteTexto,
  })
}

let pesquisaSeq = 0

/**
 * Busca assíncrona para react-select Async (sem debounce manual — evita promises pendentes).
 * @param {{ todos?: boolean }} [opcoes] todos: inclui fornecedores e inativos (usado em filtros)
 */
export async function pesquisarClientesFinanceiro(termo, opcoes = {}) {
  const q = String(termo ?? '').trim()
  if (q.length < 2) {
    return []
  }

  const seq = ++pesquisaSeq

  try {
    const { data } = await api.get('parceiros/clientes/pesquisar', {
      params: { pesquisa: q, ...(opcoes?.todos ? { todos: 1 } : {}) },
    })

    if (seq !== pesquisaSeq) {
      return []
    }

    const lista = Array.isArray(data?.clientes) ? data.clientes : []
    return lista.map(parceiroApiParaSelect)
  } catch (err) {
    if (seq === pesquisaSeq) {
      console.error('[pesquisarClientesFinanceiro]', err)
    }
    return []
  }
}
